import {Button, Select, Typography} from "antd";
import ProjectInfo from "./ProjectInfo";
import {useEffect, useState} from "react";

export default function SelectPlan({modelA, modelB, onPlanChanged, style={}, disabled, value}) {
    const getProject = (id) => {
        if(!id)
            return {}

        let item = modelA.projectFiles.find(x => x.id === id)
        if(item)
        {
            return {
                project: modelA,
                plan: item,
                model: 'A',
                projectHash: item.projectHash,
                id
            }
        }

        item = modelB.projectFiles.find(x => x.id === id)
        if(item)
        {
            return {
                project: modelB,
                plan: item,
                model: 'B',
                projectHash: item.projectHash,
                id
            }
        }
    }

    useEffect(() => {
        if(value) {
            let project = modelA.projectFiles.find(x => x.id === value)
            if(project)
                return

            project = modelB.projectFiles.find(x => x.id === value)
            if(project)
                return
        }

        onPlanChanged(getProject(null) || {})
    }, [modelA, modelB])

    useEffect(() => {
        onPlanChanged(getProject(value) || {})
    }, [value])

    return (
        <>
            <Select
                disabled={disabled}
                size={'small'}
                style={{minWidth: 300, ...style}}
                value={value}
                onSelect={(val) => {
                    // setId(val)
                    onPlanChanged(getProject(val) || {})
                }}
                placeholder={'Select Plan'}
                allowClear={true}
                onClear={() => {
                    // setId(null)
                    onPlanChanged(getProject(null) || {})
                }}
            >
                {
                    modelA && modelA.projectFiles?.length > 0 && (
                        <>
                            <Select.OptGroup label={'Model A'}>
                                {
                                    modelA.projectFiles.filter(x => x.type).map(plan => {
                                        return (
                                            <Select.Option value={plan.id} key={plan.id}>
                                                {plan.type}
                                            </Select.Option>
                                        )
                                    })
                                }
                            </Select.OptGroup>
                        </>
                    )
                }
                {
                    modelB && modelB.projectFiles?.length > 0 && (
                        <>
                            <Select.OptGroup label={'Model B'}>
                                {
                                    modelB.projectFiles.filter(x => x.type).map(plan => {
                                        return (
                                            <Select.Option value={plan.id} key={plan.id}>
                                                {plan.type}
                                            </Select.Option>
                                        )
                                    })
                                }
                            </Select.OptGroup>
                        </>
                    )
                }
            </Select>
        </>
    )
}